import { createSelector } from '@reduxjs/toolkit'

interface AuthSignupState {
  auth?: {
    error?: {
      signup?: string[]
    }
    signup?: SignupState
  }
}

interface SignupState {
  isFetching: boolean
  [key: string]: unknown
}

interface SignupSelectorState {
  errors: string[]
  signup: SignupState
}

const defaultSignupState: SignupState = {
  isFetching: false,
}

const selectErrors = (state: Record<string, unknown>) => (state as AuthSignupState).auth?.error?.signup
const selectSignup = (state: Record<string, unknown>) => (state as AuthSignupState).auth?.signup

export default createSelector(selectErrors, selectSignup, (errors, signup): SignupSelectorState => {
  return {
    errors: Array.isArray(errors) ? errors : [],
    signup: signup ?? defaultSignupState,
  }
})
